import moment from 'moment';
import { TimeArray } from '../../../Experiences/Owner/Property/TimeArray';
import { CommercialDetails } from '../../../../types/experience';

export function addHours(start: any, end: any) {
    const mins =
        moment.duration(start).asMinutes() + moment.duration(end).asMinutes();
    function z(n: any) {
        return (n < 10 ? '0' : '') + n;
    }
    const h = ((mins / 60) | 0) % 24;
    const m = mins % 60;
    return z(h) + ':' + z(m);
}

export function subHours(start: any, end: any) {
    const mins =
        moment.duration(start).asMinutes() - moment.duration(end).asMinutes();
    function z(n: any) {
        return (n < 10 ? '0' : '') + n;
    }
    const h = ((mins / 60) | 0) % 24;
    const m = mins % 60;
    return z(h) + ':' + z(m);
}

/** Same-day hour validation applies only when min or max hire is under 24h (matches backend). */
export const shouldValidateSameDayHireHours = (
    minHireHours: number,
    maxHireHours: number,
) => maxHireHours < 24 || minHireHours < 24;

export const getCheckoutTimeArray = (
    startDate: string,
    endDate: string,
    checkoutT: string,
    checkinT: string,
    experienceDetails: any,
    checkinTime: string,
) => {
    const min = experienceDetails.minHireHours;
    const max = experienceDetails.maxHireHours;
    const timeToAdd = moment(min, 'HH').format('HH:mm');
    const maxTimeToAdd = moment(max, 'HH').format('HH:mm');

    return startDate === endDate
        ? TimeArray?.filter((element: any) => {
              const checkinTimeSelected =
                  checkinTime === '' ? checkinT : checkinTime;
              const minEndTime =
                  min < 24
                      ? addHours(checkinTimeSelected, timeToAdd)
                      : checkinTimeSelected;
              const maxEndTime =
                  typeof max === 'number' && Number.isFinite(max) && max < 24
                      ? addHours(checkinTimeSelected, maxTimeToAdd)
                      : null;
              const meetsMinHire =
                  min < 24 ? element.value >= minEndTime : true;
              if (
                  experienceDetails?.visitType === 'business' &&
                  experienceDetails?.type === 'property'
              ) {
                  return (
                      element.value > checkinTimeSelected &&
                      element.value <= checkoutT &&
                      meetsMinHire &&
                      (maxEndTime ? element.value <= maxEndTime : true)
                  );
              } else if (
                  experienceDetails?.visitType === 'personal' &&
                  experienceDetails?.type === 'property'
              ) {
                  return (
                      element.value > checkinTimeSelected &&
                      element.value <= checkoutT &&
                      meetsMinHire &&
                      (maxEndTime ? element.value <= maxEndTime : true)
                  );
              } else if (
                  experienceDetails?.type === 'activity' ||
                  experienceDetails?.type === 'boat'
              ) {
                  if (max >= 24) {
                      //

                      return (
                          element.value > checkinTimeSelected &&
                          element.value <= checkoutT &&
                          meetsMinHire &&
                          (maxEndTime ? element.value <= maxEndTime : true)
                      );
                  } else {
                      return (
                          element.value > checkinTimeSelected &&
                          element.value <= checkoutT &&
                          meetsMinHire &&
                          (maxEndTime ? element.value <= maxEndTime : true) &&
                          element.value >=
                              addHours(
                                  checkinTime ? checkinTime : checkinT,
                                  timeToAdd,
                              )
                      );
                  }
              } else {
                  return (
                      element.value > checkinTimeSelected &&
                      element.value <= checkoutT &&
                      meetsMinHire &&
                      (maxEndTime ? element.value <= maxEndTime : true)
                  );
              }
          })
        : TimeArray?.filter((element: any) => {
              return element.value <= checkoutT;
          });
};

export const getCheckinTimeArray = (
    startDate: string,
    endDate: string,
    checkoutT: string,
    checkinT: string,
    experienceDetails: any,
) => {
    const min = experienceDetails.minHireHours;
    const max = experienceDetails.maxHireHours;
    const timeToAdd = moment(min, 'HH').format('HH:mm');

    return startDate === endDate && checkoutT > checkinT
        ? TimeArray?.filter((element: any) => {
              if (
                  experienceDetails?.visitType === 'business' &&
                  experienceDetails?.type === 'property'
              ) {
                  return (
                      element.value >= checkinT && element.value <= checkoutT
                  );
              } else if (
                  experienceDetails?.visitType === 'personal' &&
                  experienceDetails?.type === 'property'
              ) {
                  return (
                      element.value >= checkinT && element.value <= checkoutT
                  );
              } else if (
                  experienceDetails?.type === 'activity' ||
                  experienceDetails?.type === 'boat'
              ) {
                  if (max >= 24) {
                      return (
                          element.value >= checkinT &&
                          element.value <= checkoutT
                      );
                  } else {
                      return (
                          element.value >= checkinT &&
                          element.value <= checkoutT &&
                          element.value <= subHours(checkoutT, timeToAdd)
                      );
                  }
              } else {
                  return element.value >= checkinT;
              }
          })
        : TimeArray?.filter((element: any) => {
              return element.value >= checkinT;
          });
};

export const getAvailableSpaces = (
    commercialAvailability: Record<string, number> | null,
    experienceDetails: any,
) => {
    const commercialDetails = experienceDetails.details as CommercialDetails;

    return commercialAvailability
        ? Object.keys(commercialAvailability)
              .filter((key) => {
                  const spaceTypeAvailable =
                      (commercialDetails as any)[key] > 0;
                  return (
                      key !== 'conflictingBookingIds' &&
                      key !== 'privateOfficeSpaces' &&
                      key !== 'meetingRoomSpaces' &&
                      spaceTypeAvailable
                  );
              })
              .map((key) => {
                  const isUnavailable = commercialAvailability[key] <= 0;

                  const keyToLabelMap: { [key: string]: string } = {
                      desks: 'Dedicated Desk',
                      privateOffices:
                          commercialDetails?.subType === 'house'
                              ? 'Room'
                              : 'Private Office',
                      meetingRooms: 'Meeting Room',
                  };
                  return {
                      value: key?.slice(0, -1),
                      label: `${keyToLabelMap[key] || key?.slice(0, -1)}${
                          isUnavailable ? ' (unavailable)' : ''
                      }`,
                      isUnavailable,
                  };
              })
        : [];
};
